import { useRef, useState } from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Button, Flex, Text, Stack, Icon, Heading, Box, useToast } from "@chakra-ui/react";
import { FaCloudUploadAlt } from "react-icons/fa";
import { POST } from "../../utils/ApiRequestProvider";
import { useSelector } from "react-redux";

export interface AddDocumentType {
    isOpen: boolean;
    onClose: () => void;
    DocType: string;
    RefreshList?: () => void;
}
export default function AddDocument({
    isOpen,
    onClose,
    DocType,
    RefreshList
}: AddDocumentType) {
    const business = useSelector((state: any) => state.selections.value?.business);
    const toast = useToast();
    const [, setIsLoading] = useState(false);
    const fileRef = useRef<HTMLInputElement>(null);
    const formRef = useRef<HTMLFormElement>(null);

    function onFileChange() {
        setIsLoading(true);
        if (
            fileRef.current?.files?.length !== undefined
        ) {
            if (fileRef.current.files.length === 0) return toast({
                status: "error",
                title: "No Files Selected!",
                description: "Please upload some files first!",
                duration: 1000,
                position: "top-right"
            });
            (async () => {
                const formData = new FormData(formRef.current ?? new HTMLFormElement());
                const response = await POST("/api/Documents/create", formData);
                toast({
                    status: response.status,
                    title: response.message,
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });


                if (response.status === 'success') {
                    RefreshList && RefreshList();
                    onClose();
                }
            })()
        }
        else {
            toast({
                status: "error",
                title: "Something Went Wrong!",
                description: "An unexpected error occured while proceeding your request. The page will reload in 2-3 seconds!",
                duration: 1000,
                position: "top-right"
            });
            window.location.reload();
        }
        setIsLoading(false);
    }

    return (
        <Modal
            isCentered
            size={'lg'}
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay
                bg='blackAlpha.300'
                backdropFilter='blur(10px)'
            />
            <ModalContent>
                <ModalHeader
                    as={Stack}
                    direction={'row'}
                    borderBottom={'2px'}
                    borderBottomColor={'gray.300'}
                >
                    <Icon
                        as={FaCloudUploadAlt}
                        fontSize={'5xl'}
                        color={'primary.400'}
                    />
                    <Stack spacing={1}>
                        <Heading fontSize={'xl'}>Upload {DocType}</Heading>
                        <Text fontSize={'sm'}>Upload new {DocType} from here</Text>
                    </Stack>
                </ModalHeader>
                <ModalBody>
                    <Box hidden>
                        <form ref={formRef}>
                            <input type={'hidden'} name="Source" value={"web"} />
                            <input type={'hidden'} name="BusinessId" value={business?.id} />
                            <input type={'hidden'} name="DocumentType" value={DocType.replaceAll(" ", "")} />
                            <input type={'hidden'} name="documentType" value={DocType.replaceAll(" ", "")} />
                            <input name="Files" onChange={onFileChange} type={"file"} multiple ref={fileRef} />
                        </form>
                    </Box>
                    <Flex
                        h={'36'}
                        alignItems="center"
                        justifyContent="center"
                        cursor={'pointer'}
                        rounded={'lg'}
                        _hover={{ bg: 'gray.100' }}
                        onClick={() => fileRef.current?.click()}
                    >
                        <FaCloudUploadAlt size={24} />
                        <Text ml={2}>Click here to upload files</Text>
                    </Flex>
                </ModalBody>
                <ModalFooter
                    as={Stack}
                    direction={'row'}
                    spacing={4}
                    borderTop={'2px'}
                    borderTopColor={'gray.300'}
                >
                    <Button
                        w={'full'}
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}